function ProfilePage() {
  return (
    <>
      <p>프로필</p>
    </>
  )
}

export default ProfilePage
